import { useEffect, useState } from "react";
import BotaoContato from "../../componentes/BotaoContato/BotaoContato.js";
import "../ServicosEngAplicadaProjTec/ServicosEngAplicadaProjTec.css";
import BannerPaginaInterna from "../BannerPaginaInterna/BannerPaginaInterna.js";
import Projetos from "../Projetos/Projetos.js";
import Contato from "../Contato/Contato.js";
import Servicos from "../Servicos/Servicos.js";

function ServicosSegurancaDoTrabalho() {
  const [openItem, setOpenItem] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal-zoom");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 },
    );

    elements.forEach((el) => observer.observe(el));
    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div>
     <BannerPaginaInterna
  tag="Segurança do Trabalho"
  titulo="Segurança do Trabalho"
  descricao="Nossos serviços são voltados para organizações que buscam melhorar seu desempenho ambiental, fortalecer sua governança e atender às exigências de mercado, investidores e órgãos reguladores, com abordagem técnica e orientada a resultados."
  textoBotao="Solicitar Orçamento"
  rotaBotao="https://wa.me/5532984053160?text=Olá, quero um orçamento para Segurança do Trabalho"
  mostrarBotaoOutline={true}
  textoBotaoOutline="Fale com Especialista"
  rotaBotaoOutline="https://wa.me/5532984053160?text=Olá, quero falar com um especialista em Segurança do Trabalho"
/>

      <main className="servicos-page py-5">
        {/* HEADER */}

        {/* LISTA COM DETAILS */}
        <section className="s scroll-reveal-zoom">
          <div className="titulo-bloco">
            <h2>Nossos Serviços Especializados</h2>
            <p>
              Clique nos itens abaixo para conhecer detalhes de nossa atuação
              técnica.
            </p>
          </div>

          <p>
  A Âmbar Soluções em Engenharia e Meio Ambiente atua com <strong>segurança do trabalho</strong>, oferecendo soluções completas para empresas que buscam <strong>reduzir riscos ocupacionais, garantir conformidade com as Normas Regulamentadoras (NRs) e promover ambientes de trabalho seguros</strong>. Nossos serviços são voltados para prevenção de acidentes, proteção dos colaboradores e atendimento à legislação trabalhista vigente.
</p>

<p>
  Desenvolvemos e implementamos o <strong>Programa de Gerenciamento de Riscos (PGR)</strong>, conforme a <strong>NR-01</strong>, além da elaboração de <strong>Plano de Ação Emergencial (PAE)</strong>, com foco na preparação e resposta a situações críticas. Atuamos com <strong>identificação, avaliação e controle de riscos ocupacionais</strong>, garantindo maior segurança operacional e eficiência na gestão de riscos.
</p>

<p className="mb-4">
  Também elaboramos <strong>laudos de insalubridade e periculosidade</strong>, com base nas <strong>Normas Regulamentadoras</strong> e na legislação trabalhista, realizando avaliações técnicas detalhadas. Com <strong>alto rigor técnico, segurança jurídica e atendimento personalizado</strong>, entregamos soluções completas em <strong>segurança do trabalho para empresas</strong> de diversos segmentos.
</p>

          <div className="accordion">
            <div className="accordion">
{/* ITEM XX */}
<details className="item" open={openItem === 23} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 23 ? null : 23); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Programa de Gerenciamento de Riscos (PGR)</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Elaboramos e implementamos o <strong>Programa de Gerenciamento de Riscos (PGR)</strong>,
        conforme a <strong>NR-01</strong>, com foco na identificação, avaliação e controle dos
        <strong> riscos ocupacionais</strong>.
        <br />
        O PGR inclui o <strong>inventário de riscos</strong> e o
        <strong> plano de ação</strong>, garantindo conformidade legal e
        <strong> segurança no ambiente de trabalho</strong>.
        <br />
        Atuamos na estruturação completa e no acompanhamento contínuo,
        promovendo <strong>redução de acidentes</strong> e melhoria das condições operacionais.
      </p>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: PGR"
      />
    </div>
  </div>
</details>
{/* ITEM XX */}
<details className="item" open={openItem === 24} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 24 ? null : 24); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Plano de Ação Emergencial (PAE)</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Desenvolvemos o <strong>Plano de Ação Emergencial (PAE)</strong> para preparação e resposta
        a <strong>situações de emergência</strong>, minimizando impactos à
        <strong> vida, meio ambiente e patrimônio</strong>.
        <br />
        O plano contempla <strong>cenários de risco</strong>,
        <strong> procedimentos operacionais</strong>, definição de
        <strong> responsabilidades</strong> e estratégias de <strong>resposta rápida</strong>.
        <br />
        Garantimos alinhamento com <strong>exigências legais</strong> e melhores práticas,
        aumentando a <strong>segurança e capacidade de resposta</strong> da empresa.
      </p>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: PAE"
      />
    </div>
  </div>
</details>
{/* ITEM XX */}
<details className="item" open={openItem === 25} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 25 ? null : 25); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Laudo de Insalubridade e Periculosidade</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Elaboramos <strong>laudos técnicos de insalubridade e periculosidade</strong>,
        com base nas <strong>Normas Regulamentadoras (NRs)</strong> e na legislação trabalhista.
        <br />
        Realizamos <strong>avaliações qualitativas e quantitativas</strong> dos agentes de risco,
        identificando a necessidade de <strong>adicionais legais</strong> e medidas de controle.
        <br />
        Nossos laudos garantem <strong>segurança jurídica</strong>,
        <strong> conformidade legal</strong> e suporte técnico para auditorias e fiscalizações.
      </p>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Laudos de Insalubridade e Periculosidade"
      />
    </div>
  </div>
</details>
              </div>  
          </div>
        </section>
      </main>
      <Projetos />
      <Servicos />
      <Contato />
    </div>
  );
}

export default ServicosSegurancaDoTrabalho;
